export default __webpack_public_path__ + "img/component-info-2.5212a3a6.png";